import axios from 'axios';

const BASEURL = process.env.REACT_APP_AUTH_BASEURL;

export const sendLogin = async (userIdx) => {
  try {
    const res = await axios.post(`${BASEURL}/login`, { user_key: userIdx });
    const token = res.data.access_token;
    localStorage.setItem('authToken', token);
    return token;
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
};